import { trackEvent } from 'modules/common/lib/amplitude/trackEvent'
import { useCallback } from 'react'
import { EnumAuthTrackingEvents } from '../lib/tracking/events'
import {
  PublicSponsorshipVoucherLazyQueryOptions,
  usePublicSponsorshipVoucherLazyQuery,
} from '../queries/usePublicSponsorshipVoucherLazyQuery'
import { useSignupStoreActions } from '../store/useSignupStore'

interface Props {
  voucherCode: string | undefined
  queryOptions?: PublicSponsorshipVoucherLazyQueryOptions
}
export const useValidateSponsorshipVoucherCodeFlow = ({
  voucherCode,
  queryOptions,
}: Props) => {
  const { updateSignupData } = useSignupStoreActions()

  const { onSuccess } = queryOptions || {}
  const { fetchQuery: getPublicSponsorshipVoucher, isFetching } =
    usePublicSponsorshipVoucherLazyQuery({
      voucherCode,
      queryOptions: {
        onSuccess: (publicSponsorshipVoucher) => {
          if (publicSponsorshipVoucher) {
            onSuccess?.(publicSponsorshipVoucher)
            updateSignupData({ publicSponsorshipVoucher })
          }
        },

        ...queryOptions,
      },
    })

  const validateSponsorshipVoucherCode = useCallback(async () => {
    trackEvent({
      eventType: EnumAuthTrackingEvents.SIGNUP_VALIDATE_VOUCHER_CODE,
    })
    await getPublicSponsorshipVoucher()
  }, [getPublicSponsorshipVoucher])

  return { validateSponsorshipVoucherCode, isFetching }
}
